import { makeStyles } from '@fluentui/react-components';

// Font family constant
export const FONT_FAMILY = "'Cormorant Garamond', serif";

// Shared style objects for inline use
export const inputStyle = {
  width: '100%',
  padding: '0.75rem',
  fontSize: '1rem',
  borderRadius: '8px',
  border: '2px solid #e0e0e0',
  backgroundColor: '#ffffff',
  transition: 'all 0.3s ease',
  fontFamily: FONT_FAMILY,
};

export const primaryButtonStyle = {
  width: '100%',
  padding: '1rem 2rem',
  fontSize: '1.1rem',
  fontWeight: 600,
  backgroundColor: 'var(--primary-color)',
  color: '#ffffff',
  border: 'none',
  borderRadius: '8px',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  fontFamily: FONT_FAMILY,
  marginTop: '1rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '0.5rem',
};

export const labelStyle = {
  display: 'block',
  marginBottom: '0.5rem',
  fontWeight: 600,
  color: 'var(--primary-color)',
  fontSize: '18px',
};

export const textareaStyle = {
  width: '100%',
  padding: '0.75rem',
  fontSize: '1rem',
  borderRadius: '8px',
  border: '2px solid #e0e0e0',
  backgroundColor: '#ffffff',
  transition: 'all 0.3s ease',
  fontFamily: FONT_FAMILY,
  resize: 'vertical' as const,
  minHeight: '100px',
};

export const errorTextStyle = {
  color: 'var(--error-color)',
  fontSize: '0.875rem',
  marginTop: '0.25rem',
  fontWeight: 500,
};

export const useSharedStyles = makeStyles({
  formElementSpacing: {
    marginBottom: '1.5rem',
  },
  spinner: {
    width: '20px',
    height: '20px',
    border: '2px solid transparent',
    borderTop: '2px solid #ffffff',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
});